import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useLocation } from 'react-router-dom';
import CustomDrawer from '../shared/components/CustomDrawer';
import FallbackRender from '../shared/components/FallBackrender';
import { isUserClient } from '../shared/utils/utils';
import { getColors } from '../theme';

const colors = getColors();

function AppContent({ drawopen, open }) {
  const isClient = isUserClient();
  const location = useLocation();
  const [resetKey, setResetKey] = useState(0);
  const newKey = `${location.pathname}-${location.search}`;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { colorShades } = colors;
  const handleClose = () => {
    setIsDrawerOpen(false);
  };
  useEffect(() => {
    setResetKey((prev) => prev + 1);
  }, [newKey]);
  let marginLeftValue = '0px';

  if (drawopen) {
    if (open || !drawopen) {
      marginLeftValue = '18px';
    } else {
      marginLeftValue = '90px';
    }
  } else {
    marginLeftValue = '248px';
  }
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        width: 0,
        backgroundColor: colorShades.lightWhite,
        marginLeft: isClient ? 0 : marginLeftValue,
        marginRight: '8px',
        marginBottom: '8px',
        borderRadius: '20px',
        paddingBottom: '10px',
      }}
    >
      <ErrorBoundary key={resetKey} FallbackComponent={FallbackRender}>
        <Outlet />
        <CustomDrawer position="left" isOpen={isDrawerOpen} handleClose={handleClose} width={280} />
      </ErrorBoundary>
    </Box>
  );
}

export default AppContent;
